import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { Password, PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';
import { MessagesModule } from 'primeng/messages';
// import { AppFloatingConfigurator } from '../../layout/component/app.floatingconfigurator';
import { AppFloatingConfigurator } from '../layout/component/app.floatingconfigurator';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { InMemoryStorageService } from '../services/in-memory-storage.service';
import { SessionService } from '../services/session.service';
import { DialogModule } from 'primeng/dialog';
import { UserService } from '../pages/service/user.service';
import { TokenService } from '../Interceptor/token.service';
import { Subject, takeUntil } from 'rxjs';
import { AuthGuard } from '../auth.guard';
import { LoaderService } from '../services/loader.service';
import { LayoutService } from '../layout/service/layout.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { VersionUpdateService } from '../services/version-update.service';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [DialogModule, ButtonModule, ToastModule, CheckboxModule, InputTextModule, PasswordModule, FormsModule, RouterModule, RippleModule, AppFloatingConfigurator, CommonModule, FormsModule, RouterModule, MessagesModule,ConfirmDialogModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  providers: [ConfirmationService, MessageService]
})
export class LoginComponent implements OnInit, OnDestroy {
  signUp() {
    throw new Error('Method not implemented.');
  }
  @ViewChild('passwordInput') passwordInput!: Password;


  showForgotPasswordEmailDialog: boolean = false;  // Step 1
  showOtpDialog: boolean = false;                 // Step 2
  showForgotPasswordDialog: boolean = false;      // Step 3

  forgotEmail: string = '';
  emailTouched: boolean = false;
  forgotPasswordSubmitted: boolean = false;

  otp: string = '';
  otpTouched: boolean = false;

  newPassword: string = '';
  passwordTouched: boolean = false;

  confirmPassword: string = '';
  confirmPasswordTouched: boolean = false;

  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;

  passwordError: string = '';
  passwordMatchError: string = '';
  passwordStrengthLabel: string = '';
  passwordStrengthColor: string = 'red';
  passwordStrengthPercent: string = '0%';

  otp1 = ''; otp2 = ''; otp3 = ''; otp4 = ''; otp5 = ''; otp6 = '';
 openDialog(dialog: 'email' | 'otp' | 'forgot'): void {
  // Close all dialogs first
  this.showForgotPasswordEmailDialog = false;
  this.showOtpDialog = false;
  this.showForgotPasswordDialog = false;

  // Reset all related fields
  this.forgotPasswordSubmitted = false;
  this.forgotEmail = '';
  this.otp1 = this.otp2 = this.otp3 = this.otp4 = this.otp5 = this.otp6 = '';
  this.newPassword = '';
  this.confirmPassword = '';
  this.passwordTouched = false;
  this.confirmPasswordTouched = false;
  this.passwordError = '';
  this.passwordMatchError = '';

  // Open the requested dialog
  if (dialog === 'email') this.showForgotPasswordEmailDialog = true;
  if (dialog === 'otp') {
    this.otpTouched = false;
    this.showOtpDialog = true;
  }
  if (dialog === 'forgot') {
    this.showForgotPasswordDialog = true;
    this.passwordTouched = false;
    this.confirmPasswordTouched = false;
  }
}

closeDialog(dialog: 'email' | 'otp' | 'forgot'): void {
  if (dialog === 'email') this.showForgotPasswordEmailDialog = false;
  if (dialog === 'otp') this.showOtpDialog = false;
  if (dialog === 'forgot') this.showForgotPasswordDialog = false;
}



  focusPassword() {
    setTimeout(() => {
      this.passwordInput?.input?.nativeElement?.focus();
    });
  }
  sendForgotLink() {

  }

  sendForgotPasswordEmailOTP(): void {
    this.emailTouched = true;
    this.forgotPasswordSubmitted = true;

    if (!this.forgotEmail) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Missing Email',
        detail: 'Please enter your registered email address.',
        life: 2000
      });
      return;
    }

    this.loaderService.show('Sending OTP...','Please wait...');

    this.userService.sendForgotPasswordLink(this.forgotEmail).subscribe({
      next: (res: any) => {
        this.loaderService.hide();
        this.showForgotPasswordEmailDialog = false; // close email popup
        this.showOtpDialog = true;             // open OTP popup

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `OTP sent to ${this.forgotEmail}`,
          life: 4000
        });

        // Do NOT clear forgotEmail here
        this.emailTouched = false;
      },
 error: (err) => {
  this.loaderService.hide();

  let backendMsg = 'Failed to send reset link. Please try again later.';

  if (err?.error) {
    if (typeof err.error === 'string') {
      try {
        // If backend sends JSON as string
        const parsed = JSON.parse(err.error);
        backendMsg = parsed.message || backendMsg;
      } catch {
        backendMsg = err.error; // fallback to raw string
      }
    } else if (typeof err.error === 'object') {
      backendMsg = err.error.message || backendMsg;
    }
  }

  this.messageService.add({
    severity: 'error',
    summary: 'Error',
    detail: backendMsg,
    life: 4000
  });

  console.error('Error sending reset link', err);
}


    });
  }

  focusNext(event: any, index: number) {
    const input = event.target;
    if (input.value.length === 1) {
      const nextInput = input.nextElementSibling;
      if (nextInput) nextInput.focus();
    }
  }

  // Handle backspace to move to previous input
  handleBackspace(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && input.value === '') {
      const prevInput = input.previousElementSibling as HTMLInputElement;
      if (prevInput) prevInput.focus();
    }
  }


  isOtpComplete(): boolean {
    return !!(this.otp1 && this.otp2 && this.otp3 && this.otp4 && this.otp5 && this.otp6);
  }

  getOtp(): string {
    return `${this.otp1}${this.otp2}${this.otp3}${this.otp4}${this.otp5}${this.otp6}`;
  }

  // Component Methods


  verifyOtp(): void {
    this.otpTouched = true;

    if (!this.isOtpComplete()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Incomplete OTP',
        detail: 'Please enter the full verification code.',
        life: 2000
      });
      return;
    }

    const otpValue = this.getOtp();

    this.loaderService.show('Verifying OTP...','Please wait...');

    this.userService.verifyOtp(this.forgotEmail, otpValue).subscribe({
      next: () => {
        this.loaderService.hide();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'OTP verified successfully!',
          life: 3000
        });

        // Open Reset Password dialog instead of Forgot Password dialog
        this.showOtpDialog = false;
        this.showForgotPasswordDialog = true;
      },
      error: (err) => {
        this.loaderService.hide();
        const backendMsg = err?.error?.message || 'Invalid OTP. Please try again.';
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: backendMsg,
          life: 4000
        });
      }
    });
  }

  resendOtp(): void {
    if (!this.forgotEmail) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Missing Email',
        detail: 'Cannot resend OTP because email is missing.',
        life: 2000
      });
      return;
    }

    this.loaderService.show('Resend OTP...','Please wait...');

    this.userService.sendForgotPasswordLink(this.forgotEmail).subscribe({
      next: () => {
        this.loaderService.hide();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `OTP has been resent to ${this.forgotEmail}`,
          life: 4000
        });
      },
      error: (err) => {
        this.loaderService.hide();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.message || 'Failed to resend OTP',
          life: 4000
        });
      }
    });
  }
  forgotPassword(): void {
    this.passwordTouched = true;
    this.confirmPasswordTouched = true;

    if (!this.newPassword || this.newPassword !== this.confirmPassword) return;

    this.loaderService.show('Resetting password...','Please wait...');

    this.userService.otpForgotPassword(this.forgotEmail, this.newPassword, this.confirmPassword)
      .subscribe({
        next: () => {
          this.loaderService.hide();

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Password has been reset successfully!',
            life: 4000
          });

          // Close dialog & clear fields
          this.showForgotPasswordDialog = false;
          this.newPassword = '';
          this.confirmPassword = '';
          this.forgotEmail = '';
          this.otp1 = this.otp2 = this.otp3 = this.otp4 = this.otp5 = this.otp6 = '';
        },
        error: (err) => {
          this.loaderService.hide();
          const backendMsg = err?.error?.message || 'Failed to reset password';
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: backendMsg,
            life: 4000
          });
        }
      });
  }


  validatePassword() {
    const password = this.newPassword || '';
    const minLength = password.length >= 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    // Existing validation errors
    if (!password) {
      this.passwordError = 'Password is required.';
    } else if (!minLength) {
      this.passwordError = 'Password must be at least 8 characters.';
    } else if (!hasUpperCase) {
      this.passwordError = 'Must contain at least one uppercase letter.';
    } else if (!hasLowerCase) {
      this.passwordError = 'Must contain at least one lowercase letter.';
    } else if (!hasNumber) {
      this.passwordError = 'Must contain at least one number.';
    } else if (!hasSpecialChar) {
      this.passwordError = 'Must contain at least one special character.';
    } else {
      this.passwordError = '';
    }

    // Calculate strength
    let strengthPoints = 0;
    if (minLength) strengthPoints++;
    if (hasUpperCase) strengthPoints++;
    if (hasLowerCase) strengthPoints++;
    if (hasNumber) strengthPoints++;
    if (hasSpecialChar) strengthPoints++;

    switch (strengthPoints) {
      case 0:
      case 1:
      case 2:
        this.passwordStrengthLabel = 'Weak';
        this.passwordStrengthColor = 'red';
        this.passwordStrengthPercent = '40%';
        break;
      case 3:
      case 4:
        this.passwordStrengthLabel = 'Medium';
        this.passwordStrengthColor = 'orange';
        this.passwordStrengthPercent = '70%';
        break;
      case 5:
        this.passwordStrengthLabel = 'Strong';
        this.passwordStrengthColor = 'green';
        this.passwordStrengthPercent = '100%';
        break;
    }

    // Revalidate confirm password
    this.validatePasswordMatch();
  }

  validatePasswordMatch() {
    if (this.confirmPassword && this.newPassword !== this.confirmPassword) {
      this.passwordMatchError = 'Passwords do not match.';
    } else {
      this.passwordMatchError = '';
    }
  }


  // resetPassword() {
  //   this.otpTouched = true;
  //   this.passwordTouched = true;
  //   this.confirmPasswordTouched = true;

  //   if (!this.otp || !this.newPassword || !this.confirmPassword) return;

  //   if (this.newPassword !== this.confirmPassword) {
  //     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Passwords do not match' });
  //     return;
  //   }

  //   this.loading = true;
  //   this.http.post(`${environment.authApiUrl}reset-password`, {
  //     email: this.forgotEmail,
  //     otp: this.otp,
  //     newPassword: this.newPassword
  //   }).pipe(takeUntil(this.destroy$))
  //     .subscribe({
  //       next: (res: any) => {
  //         this.loading = false;
  //         this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Password reset successfully' });
  //         this.showOtpDialog = false;
  //         // Reset all fields
  //         this.forgotEmail = this.otp = this.newPassword = this.confirmPassword = '';
  //         this.otpTouched = this.passwordTouched = this.confirmPasswordTouched = false;
  //       },
  //       error: (err) => {
  //         this.loading = false;
  //         const msg = err?.error?.message || 'Failed to reset password';
  //         this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
  //       }
  //     });
  // }


  private destroy$ = new Subject<void>();

  email = '';
  password = '';
  errorMessage = '';
  checked = '';
  registerDialog: boolean = false;
  submitted: boolean = false;
  reEnteredPassword: string = '';
  registerData = {
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    userName: '',
    countryCode: '+91',
    mobileNumber: '',
    password: ''
  };
  constructor(
    private sessionService: SessionService,
    private inMemoryStorageService: InMemoryStorageService,
    private http: HttpClient,
    private router: Router,
    private messageService: MessageService,
    private userService: UserService,
    private tokenService: TokenService,
    private authService: AuthGuard,
    private loaderService: LoaderService,
    public layoutService: LayoutService,
    private confirmationService: ConfirmationService,
    private versionUpdateService: VersionUpdateService
  ) { }
  ngOnInit(): void {
    // console.log('heartbeat started');
    //   localStorage.clear();

    // Start heartbeat when the user logs in
    // this.sessionService.startHeartbeat();
    const orders = localStorage.getItem('orders');
    const orderLines = localStorage.getItem('orderLines');
    const routeParams = localStorage.getItem('routeParams');
    const appVersion = localStorage.getItem('appVersion');
    const themePreference = localStorage.getItem('app-theme-preference'); // Preserve theme
    console.log('appVersion', appVersion);

    localStorage.clear();

    if (orders !== null) localStorage.setItem('orders', orders);
    if (orderLines !== null) localStorage.setItem('orderLines', orderLines);
    if (routeParams !== null) localStorage.setItem('routeParams', routeParams);
    if (appVersion !== null) localStorage.setItem('appVersion', appVersion);
    if (themePreference !== null) localStorage.setItem('app-theme-preference', themePreference); // Restore theme
    
    // Apply theme on login page - use setTimeout to ensure DOM is ready
    setTimeout(() => {
      this.layoutService.loadThemeFromStorage();
    }, 0);
  }

  msgs: any[] = [];

  private getPwdWarnKey(userName: string): string {
  const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
  return `pwdWarned_${userName}_${today}`;
}
openForgotPasswordFlow(): void {
  // close any existing dialogs if needed
  this.authService.logout();
  setTimeout(() => {
    this.showForgotPasswordEmailDialog = true;
  }, 1000);
}

  signIn() {
        this.loaderService.show('Signing in...', 'Please wait...');


    // Check if email and password are provided
    if (!this.email || !this.password) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Missing fields',
        detail: `Please fill in all required fields.`,
        life: 1000
      });
     this.loaderService.hide();

      return;
    }
    const username = this.email.toLowerCase(); // <-- Always use lowercase
    this.http
      .post(`${environment.authApiUrl}login`, {
        username: username,
        password: this.password
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
                          this.loaderService.hide();

          localStorage.setItem('lastRouteTime', Date.now().toString());
          if (res.message === 'Login successful.') {
            localStorage.removeItem('userProfile');
            localStorage.removeItem('accessToken');

            localStorage.setItem('accessToken', res.accessToken);
            localStorage.setItem('userProfile', JSON.stringify(res));
            this.inMemoryStorageService.set('accessToken', res.accessToken);
            this.inMemoryStorageService.set('userName', res.userName);
            this.inMemoryStorageService.set('userProfile', JSON.stringify(res));
            this.tokenService.setToken(res.accessToken);
          console.log('passwordExpirationIn from API:', res.passwordExpirationIn);
console.log('type:', typeof res.passwordExpirationIn);
           if (res.passwordExpirationIn <= 0) {
  this.confirmationService.confirm({
    header: 'Password Expired',
    message: 'Your password has expired. You must reset your password to continue.',
    closable: false,
    acceptLabel: 'Reset Password',
    rejectVisible: false,
    accept: () => {
      this.openForgotPasswordFlow();
    }
  });
  return;
}

const warnKey = this.getPwdWarnKey(res.userName);
if (
  res.passwordExpirationIn <= 5 &&
  !sessionStorage.getItem(warnKey)
) {
  sessionStorage.setItem(warnKey, 'true');

  this.confirmationService.confirm({
    header: 'Password Expiry Warning',
    message: `Your password will expire in ${res.passwordExpirationIn} day(s).`,
    closable: false,
    acceptLabel: 'Reset Password',
    rejectLabel: 'Continue',
    accept: () => {
       this.openForgotPasswordFlow();
    },
    reject: () => {
      this.proceedAfterLogin(res);
    }
  });

  return; // ⛔ STOP FLOW until user acts
}
this.proceedAfterLogin(res);  
          } else if (res.message === 'User needs to verify their account.') {
            console.log('User needs to verify their account.');

            // Navigate to /reset-password with email and password as query params
            this.router.navigate(['/reset-password'], {
              queryParams: {
                email: this.email,
                password: this.password
              }
            });
          } else {
              this.loaderService.hide();


            this.messageService.add({
              severity: 'error',
              summary: 'Login Failed',
              detail: 'Invalid username or password.',
              life: 10000
            });
          }
        },
        error: (err) => {
          this.loaderService.hide();
          // Try to get a meaningful error message from backend response
          let backendMsg = err?.error?.message || err?.error?.error || err?.message || 'Login failed';

          this.messageService.add({
            severity: 'error',
            summary: 'Login Failed',
            detail: backendMsg,
            life: 10000
          });
        }
      });
  }
  proceedAfterLogin(res: any) {
    
            console.log(res.userName);
            if (!res.userName) {
              this.messageService.add({
                severity: 'error',
                summary: 'Login Failed',
                detail: 'Username is missing in the response.',
                life: 2000
              });
              return;
            }

            this.sessionService.startHeartbeat(res.userName);
            this.versionUpdateService.checkOnceOnLogin();

            // Call getUserProfile API after successful login, using username from login response
            const username = res.userName;
            const url = `${environment.authApiUrl}username?username=${username}`;
            this.http
              .get(url)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (profile: any) => {
                  console.log(profile);
                  console.log(profile.company);
                  console.log(profile.division);
                  console.log(profile.roleGroups);
                  console.log('Login response:', res);
                  // Check if roleGroups is empty or null
                  if (!profile.roleGroups || profile.roleGroups.length === 0) {
                    this.messageService.add({
                      severity: 'warn',
                      summary: 'No Role Assigned',
                      detail: 'Please contact your manager as no role is assigned yet.',
                      life: 10000
                    });
                    // Set a flag to show only the logout button in your template
                    this.noRoleDialogVisible = true;
                    return;
                  } else {
                    this.noRoleDialogVisible = false;
                  }
                  console.log(profile.roleGroups);

                  localStorage.setItem('roleGroup', JSON.stringify(profile.roleGroups));
                  this.inMemoryStorageService.set('roleGroup', JSON.stringify(profile.roleGroups));
                  this.inMemoryStorageService.set('company', profile.company);
                  this.inMemoryStorageService.set('division', profile.division);
                     this.inMemoryStorageService.set('email', profile.email);
                  this.inMemoryStorageService.set('userName', profile.userName);

                  this.inMemoryStorageService.set('warehouseId', profile.warehouse);
                  this.inMemoryStorageService.set('facilityId', profile.facility);

                  this.userService.setCompanyAndDivision(profile.company, profile.division);
                  this.userService.setUserName(profile.userName);

                  // localStorage.setItem('userProfile', JSON.stringify(profile));
                  // Optionally, update inMemoryStorageService or other state here
                  
                  // Ensure theme is applied before navigation
                  this.layoutService.loadThemeFromStorage();
                  
                  this.router.navigate(['/Orders1'], { replaceUrl: true });
                },
                error: (err) => {
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Profile Error',
                    detail: 'Failed to fetch user profile.',
                    life: 3000
                  });
                  // Still navigate if needed
                  // Ensure theme is applied before navigation
                  this.layoutService.loadThemeFromStorage();
                  this.router.navigate(['/Orders1']);
                }
              });
  }
  noRoleDialogVisible = false;
  logout() {
      const user = this.inMemoryStorageService.get('userName');
  if (user) {
    Object.keys(sessionStorage)
      .filter(k => k.startsWith(`pwdWarned_${user}`))
      .forEach(k => sessionStorage.removeItem(k));
  }
    this.authService.logout();
    this.noRoleDialogVisible = false;
  }
  onRegisterClick() {
    this.submitted = true;

    // Check if passwords match
    if (this.registerData.password !== this.reEnteredPassword) {
      this.messageService.add({
        severity: 'error',
        summary: 'Registration Failed',
        detail: 'Passwords do not match.',
        life: 3000
      });
      return;
    }

    this.http
      .post(`${environment.authApiUrl}register`, this.registerData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          console.log('Registration response:', res);

          this.messageService.add({
            severity: 'success',
            summary: 'Registration Successful',
            detail: 'You can now log in.',
            life: 3000
          });
          this.registerDialog = false;
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Registration Failed',
            detail: err.error?.error || 'Registration failed',
            life: 3000
          });
        }
      });
  }

  showDialog() {
    this.registerDialog = true;
  }

  hideDialog() {
    this.registerDialog = false;
  }
  ngOnDestroy(): void {
    // Signal all observables to complete and clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
    console.log('LoginComponent destroyed');
  }
}
